
import { Col, Row, Typography } from "antd";
import React from "react";

const { Text } = Typography;
export default function AllHistoryPage({colors}) {
  console.log("colors...", colors)
  const historyData = [
    {
      time: "11/10/2025\n20:35",
      provider: "assets/ca1.png",
      game: "Casino Fishing Game",
      payout: "+5000",
    },
    {
      time: "10/10/2025\n18:22",
      provider: "assets/ca2.png",
      game: "Casino Fishing Game",
      payout: "-3000",
    },
    {
      time: "09/10/2025\n15:10",
      provider: "assets/ca3.png",
      game: "Casino Fishing Game",
      payout: "+7200",
    },
    {
      time: "08/10/2025\n12:45",
      provider: "assets/ca4.png",
      game: "Casino Fishing Game",
      payout: "-1500",
    },
    {
      time: "07/10/2025\n09:30",
      provider: "assets/ca5.png",
      game: "Casino Fishing Game",
      payout: "+4200",
    },
    {
      time: "06/10/2025\n22:15",
      provider: "assets/ca6.png",
      game: "Casino Fishing Game",
      payout: "-2000",
    },
    {
      time: "05/10/2025\n19:05",
      provider: "assets/ca3.png",
      game: "Casino Fishing Game",
      payout: "+3500",
    },
    {
      time: "04/10/2025\n16:50",
      provider: "assets/ca1.png",
      game: "Casino Fishing Game",
      payout: "-1000",
    },
    {
      time: "04/10/2025\n16:50",
      provider: "assets/ca1.png",
      game: "Casino Fishing Game",
      payout: "-1000",
    }, {
      time: "04/10/2025\n16:50",
      provider: "assets/ca1.png",
      game: "Casino Fishing Game",
      payout: "-1000",
    },
  ];

  return (
    <Row gutter={[0, 16]}> 
      <Col span={24}>
        <Row
          align="middle"
          justify="space-around"
          style={{
            height: "54px",
            background: "linear-gradient(to right, #2e0e1b, #2d1c1b, #1e2b1b)",
            color: "white",
            fontWeight: 600,
            fontSize: "15px",
          
          }}
        >
          <Col>
            <Text style={{ color: "white" }} strong>
              Time
            </Text>
          </Col>
          <Col>
            <Text style={{ color: "white" }} strong>
              Provider
            </Text>
          </Col>
          <Col>
            <Text style={{ color: "white" }} strong>
              Game
            </Text>
          </Col>
          <Col>
            <Text style={{ color: "white" }} strong>
              Payout
            </Text>
          </Col>
        </Row>

        <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
          {historyData.map((item, index) => (
            <Row
              key={index}
              align="middle"
              justify="space-around"
              style={{
                height: "60px",
                backgroundColor: colors.background,
                borderRadius: "4px", 
              }}
            >
              <Col>
                <Text
                  style={{
                    color: "white",
                    whiteSpace: "pre-line",
                    textAlign: "center",
                  }}
                >
                  {item.time}
                </Text>
              </Col>
              <Col style={{ textAlign: "center" }}>
                <img
                  src={item.provider}
                  alt="provider"
                  style={{ maxHeight: "30px", maxWidth: "30px" }}
                />
              </Col>
              <Col style={{ width: "90px", textAlign: "center" }}>
                <Text style={{ color: "white" }}>{item.game}</Text>
              </Col>
              <Col>
                <Text
                  style={{
                    color: item.payout.startsWith("+") ? colors.success : colors.danger,
                    fontWeight: 500,
                    textAlign: "center",
                  }}
                >
                  {item.payout}
                </Text>
              </Col>
            </Row>
          ))}
        </div>
      </Col>
    </Row>
  );
}